import {
  ContentTypeEnum,
  type ContentBlock as ContentBlockType,
} from '../../../shared/types'

interface ContentBlockProps {
  filePath?: string
  contentBlock?: ContentBlockType
}

const useContentBlock = (props: ContentBlockProps) => {
  const { contentBlock, filePath } = props

  return {}
}

export default useContentBlock
